import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Upload, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Cookies from "universal-cookie";
// import ImgCrop from "antd-img-crop";
import colors from "constants/palette";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default function App(props) {
  const { addedImages, index } = props;
  const [state, setState] = useState({
    previewVisible: false,
    previewImage: "",
    previewTitle: "",
    fileList: [],
    failed: false,
  });

  const cookies = new Cookies();
  const token = cookies.get("__token");
  const header = {
    Authorization: `Bearer ${token}`,
  };

  useEffect(() => {
    setState((e) => ({
      ...e,
      fileList: addedImages
        ? addedImages.map((item, key) => ({
            uid: key,
            name: item,
            status: "done",
            url: item,
          }))
        : [],
    }));
  }, [index]);

  useEffect(() => {
    if (!addedImages.length && state.fileList.length) {
      handleChange({ fileList: [] });
    }
    // eslint-disable-next-line
  }, [addedImages]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    const image = new Image();
    image.src = file.url;
    const imgWindow = window.open(file.url);
    imgWindow.document.write(image.outerHTML);
  };

  const handleChange = ({ fileList, file }) => {
    if (state.failed) {
      setState((e) => ({
        ...e,
        fileList: e.fileList.filter((e) => e.name),
        failed: false,
      }));
      return false;
    }
    setState((e) => ({ ...e, fileList }));
    console.log(fileList);
    let x = fileList;
    if (x.filter((item) => item.status !== "done").length === 0) {
      props.setImage(
        fileList.map((e) =>
          e.response
            ? process.env.REACT_APP_FILE_URL + "/" + e.response.file
            : e.url
        )
      );
    }
  };

  const beforeUpload = (file) => {
    const isvalid =
      file.size / 1014 / 1014 < (props.sizelimit ? props.sizelimit : 1);
    if (!isvalid) {
      message.error(
        `حجم فایل بیشتر از ${
          props.sizelimit ? props.sizelimit : 1
        } مگابایت میباشد.
        لطفا دوباره تلاش کنید!`
      );
      message.error(
        <a href="https://imagecompressor.com/" target="_blank" rel="noreferrer">
          برای کاهش حجم تصویر کلیک کنید
        </a>
      );
      setState((e) => ({ ...e, failed: true }));
    }

    return isvalid;
  };
  const { fileList } = state;
  const uploadButton = (
    <div style={{ width: 220 }}>
      <PlusOutlined />
      <div>{props.title ? props.title : "انتخاب تصویر"}</div>
    </div>
  );
  const maxAllowed = props.maxAllowed ? props.maxAllowed : 8;
  useEffect(() => {
    console.log("TextEditor re-rendered");
  }, []);
  return (
    <Container>
      <Upload
        style={{ width: 220 }}
        action={`${process.env.REACT_APP_URL}/admin/upload`}
        listType="picture-card"
        accept={props.accept ? props.accept : ".png,.jpg,.jpeg"}
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        headers={header}
        beforeUpload={beforeUpload}
      >
        {fileList.length >= maxAllowed ? null : uploadButton}
      </Upload>
    </Container>
  );
}

const Container = styled.div`
  & .ant-upload {
    background: ${colors.white + "40"};
    color: ${colors.dark};
  }
`;
